export default __webpack_public_path__ + "5033b34f0176033408f0945db786f464.svg";